import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "selectable-list__footer" }
const _hoisted_2 = {
  key: 1,
  class: "selectable-list__inner placeholder"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_virtual_scroll = _resolveComponent("q-virtual-scroll")!

  return (_openBlock(), _createElementBlock("div", {
    class: "selectable-list__container",
    style: _normalizeStyle({ maxWidth: _ctx.maxWidth === true ? '100vw' : String(_ctx.maxWidth) })
  }, [
    (_ctx.state.Items)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["selectable-list__inner", { vertical: !_ctx.horizontal, horizontal: _ctx.horizontal, auto_overflow: _ctx.autoOverflow }]),
          ref: "scrollable_area"
        }, [
          _renderSlot(_ctx.$slots, "default", {
            state: _ctx.state,
            select: _ctx.select,
            add: _ctx.add,
            remove: _ctx.remove,
            activate: _ctx.activate,
            complete: _ctx.complete,
            completed: _ctx.completed
          }, () => [
            _createVNode(_component_q_virtual_scroll, {
              items: _ctx.state.Items,
              "virtual-scroll-horizontal": _ctx.horizontal,
              "virtual-scroll-item-size": _ctx.itemScrollSize,
              ref: "list",
              style: _normalizeStyle({ maxWidth: '100%', maxHeight: _ctx.autoOverflow ? `${_ctx.computedOverflowHeight}px` : 'unset', paddingBottom: `${parseInt(String(_ctx.overflow || '')) || 0}px` })
            }, {
              default: _withCtx(({ item, index }) => [
                (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["selectable-list__item", { final: item.status?.includes('final'), selected: _ctx.state.Selection && _ctx.state.Selection[item?.id || item], active: _ctx.state.Active === (item?.id || item) || (Array.isArray(_ctx.state.Active) && _ctx.state.Active?.includes(item?.id)), card: _ctx.cards }]),
                  ref: e => _ctx.listItemDOMElements[index]=e || _ctx.listItemDOMElements[index],
                  key: `selectable_list__item-${index}`
                }, [
                  _renderSlot(_ctx.$slots, "item", {
                    payload: item,
                    item: item,
                    meta: _ctx.itemMeta ? _ctx.itemMeta[String(item)] : undefined,
                    index: index,
                    state: _ctx.state,
                    active: _ctx.state.Active,
                    activeItem: _ctx.state.ActiveItem,
                    selected: _ctx.state.Selection && _ctx.state.Selection[item?.id || item],
                    select: _ctx.select,
                    add: _ctx.add,
                    remove: _ctx.remove,
                    activate: _ctx.activate,
                    complete: _ctx.complete,
                    completed: _ctx.completed,
                    cache: _ctx.cache,
                    updateCache: _ctx.updateCache
                  })
                ], 2))
              ]),
              _: 3
            }, 8, ["items", "virtual-scroll-horizontal", "virtual-scroll-item-size", "style"])
          ]),
          _createElementVNode("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "footer", {
              state: _ctx.state,
              select: _ctx.select,
              add: _ctx.add,
              remove: _ctx.remove,
              activate: _ctx.activate,
              complete: _ctx.complete,
              completed: _ctx.completed
            })
          ])
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, "..."))
  ], 4))
}